module.exports = __webpack_public_path__ + "img/austria-ill-defined-causes-male.781c7a4e.png";